(function ($) {
  window.DGS.CenterSpotConfig.mapBrowserWidth = true;
})(jQuery);